import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
const KEY = "blushify_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addToCart = useCallback((item) => {
    setItems((prev) => {
      if (prev.find((i) => i.name === item.name)) return prev; // avoid dup
      return [...prev, { name: item.name, price: Number(item.price) || 0, type: item.type || "service" }];
    });
    // NOTE: do not auto-open the drawer; let user keep adding and checkout later
  }, []);

  const removeItem = useCallback((name) => setItems((prev) => prev.filter((i) => i.name !== name)), []);
  const clear = useCallback(() => setItems([]), []);
  const openCart = useCallback(() => setOpen(true), []);
  const closeCart = useCallback(() => setOpen(false), []);
  const subtotal = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeItem, clear, open, setOpen, openCart, closeCart, subtotal, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
};
